import { combineReducers, configureStore } from '@reduxjs/toolkit';
import enviromentReducer from './environment/environmentSlice';
import userReducer from './environment/userSlice';

import equipmentReducer from './equipment/equipmentSlice';
import equipmentModalReducer from './equipment/equipmentModalsSlice';
import equipmentUpdateReducer from './equipment/updateEquipmentSlice';
import uploadAttchmentReducer from './equipment/uploadDocsSlice';

import contactReducer from './contact/contactSlice';
import customerReducer from './contact/getCustomerSlice';
import coOrdReducer from './contact/coOrdSlice';

import createProjectReducer from './projects/createProjectSlice';
import searchProjectsReducer from './projects/searchProjectSlice';
import projectStatusReduer from './projects/statusListSlice';
import deleteStatusReducer from './projects/deleteProjectSlice';
import projectDetailsReducer from './projects/projectDetailsSlice';
import projectDocumentsReducer from './projects/projectDocumentSlice';
import prjDocumentReducer from './projects/projectSingleDocSlice';

import layoutReducer from '../components/Layout/LayoutSlice';

const rootReducer = combineReducers({
  environment: enviromentReducer,
  user:userReducer,
  layout: layoutReducer,
  equipment: equipmentReducer,
  modals: equipmentModalReducer,
  equipmentUpdate: equipmentUpdateReducer,
  uploadDocument: uploadAttchmentReducer,
  address: contactReducer,
  customer: customerReducer,
  coordiantes:coOrdReducer,
  project: createProjectReducer,
  projects: searchProjectsReducer,
  projectStatus: projectStatusReduer,
  projectDetails: projectDetailsReducer,
  projectDocuments: projectDocumentsReducer,
  documentById: prjDocumentReducer,
  deleteStatus: deleteStatusReducer,
});

export const store = (preloadedState) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
  });
